"use client"

import { useNavigate } from "react-router-dom"
import { FaDownload, FaFileAlt, FaHome } from "react-icons/fa"
import "./AnnualReports.css"

export default function AnnualReports() {
  const navigate = useNavigate()

  const reports = [
    {
      year: "2024-25",
      summary: "Highlights from our latest programs, community outreach, and operational milestones for the year 2024-25.",
      fileUrl: "/pramila_foundation_annual_report_2024_25.pdf"
    }
  ]

  return (
    <section className="annual-reports">
      <div className="container">
        <div className="section-header">
          <h2>Annual Reports</h2>
          <div className="underline"></div>
          <p className="section-description">
            Browse our published annual reports to see our progress, impact metrics, and financial transparency.
          </p>
        </div>

        <div className="reports-grid">
          {reports.map((report) => (
            <div className="report-card" key={report.year}>
              <div className="report-icon">
                <FaFileAlt />
              </div>
              <h3>{report.year} Annual Report</h3>
              <p>{report.summary}</p>
              <button
                type="button"
                className="report-link"
                onClick={() => window.open(report.fileUrl, '_blank')}
              >
                <FaDownload /> View PDF
              </button>
            </div>
          ))}
        </div>

        <div className="home-button-container">
          <button className="home-button" onClick={() => navigate("/")}>
            <FaHome className="button-icon" /> Back to Home
          </button>
        </div>
      </div>
    </section>
  )
}
